module.exports = __webpack_public_path__ + "static/media/marcasConstruccion.c0f0493b.jpg";